import { AHIcon, Box } from "arkh";
import React, { useCallback } from "react";
import { ItemButton } from "../ItemButton";
import { View } from "react-native";

export const Toolbar = ({
  taskId,
  sectionId,
  numberOfImages,
  onSettingsPress,
  onRemoveItem,
  isOnlyTaskInstance,
  openImageActionSheet,
  anchor,
}: {
  anchor: React.MutableRefObject<
    | number
    | React.ComponentClass<any, any>
    | React.Component<any, any, any>
    | null
  >;
  isOnlyTaskInstance: boolean;
  taskId: string;
  sectionId: string;
  numberOfImages: number;
  onSettingsPress(taskId: string): void;
  onRemoveItem(_: {
    taskId: string;
    sectionId: string;
    isOnlyTaskInstance: boolean;
  }): void;
  openImageActionSheet(): void;
}) => {
  const onPressRemove = useCallback(
    () =>
      onRemoveItem({
        taskId,
        sectionId,
        isOnlyTaskInstance,
      }),
    [isOnlyTaskInstance, onRemoveItem, sectionId, taskId]
  );
  const onPressMore = useCallback(
    () => onSettingsPress(taskId),
    [onSettingsPress, taskId]
  );
  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
      spaceTop="medium"
    >
      <Box
        style={{ flexDirection: "row", alignItems: "center" }}
        spaceRight="medium"
      >
        {numberOfImages === 0 ? (
          <ItemButton onPress={openImageActionSheet}>
            <View ref={anchor as any}>
              <AHIcon type="image" color="primary" />
            </View>
          </ItemButton>
        ) : null}
        <ItemButton onPress={onPressMore}>
          <AHIcon type="more-outlined" color="primary" />
        </ItemButton>
      </Box>
      <ItemButton onPress={onPressRemove}>
        {isOnlyTaskInstance ? (
          <AHIcon type="trash" color="negative" />
        ) : (
          <AHIcon type="remove-outline" color="negative" />
        )}
      </ItemButton>
    </Box>
  );
};
